import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import Axios from "../comp/Utils/axios";
import SummaryAPI from "../comp/Commson/summaryApi";
import { AxiosToastError } from "../comp/Utils/AxiosToastError";

const Forgotpassword = () => {
  const navigate = useNavigate();

  const [data, setData] = useState({
    email: "",
  });

  // handle input change
  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  // validation function
  const validate = () => {
    if (!/\S+@\S+\.\S+/.test(data.email)) {
      toast.error("Please enter a valid email");
      return false;
    }
    return true;
  };

  const handleForgotPassword = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    try {
      const response = await Axios({
        url: SummaryAPI.forgot_password.url,
        method: SummaryAPI.forgot_password.method, // ensure backend expects same method
        data: {
          email: data.email,
        },
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response?.data?.success) {
        toast.success("OTP sent successfully 🎉");
        navigate("/verification-otp", {
          state: { email: data.email }, // fixed (was passing whole object)
        });
        setData({ email: "" });
      } else {
        toast.error(response?.data?.message || "Something went wrong");
      }
    } catch (error) {
      AxiosToastError(error);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-indigo-500 to-purple-600 p-6">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-lg p-8">
        <h2 className="text-2xl font-bold text-gray-800 text-center">
          Forgot Password
        </h2>
        <p className="text-gray-500 text-center text-sm mt-2">
          Enter your email to receive a reset OTP
        </p>

        <form onSubmit={handleForgotPassword} className="mt-6 space-y-4">
          {/* Email */}
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Email Address
            </label>
            <input
              type="email"
              name="email"
              value={data.email}
              onChange={handleChange}
              required
              placeholder="Enter your email"
              className="w-full mt-1 px-4 py-2 border rounded-lg focus:ring-2 focus:ring-indigo-400 focus:outline-none"
            />
          </div>

          {/* Button */}
          <button
            type="submit"
            className="w-full bg-indigo-600 hover:bg-indigo-700 text-white py-2 rounded-lg font-medium transition-all"
          >
            Send OTP
          </button>
        </form>

        <p className="text-sm text-center text-gray-600 mt-6">
          Already have an account?{" "}
          <span
            onClick={() => navigate("/login")}
            className="text-indigo-500 font-medium cursor-pointer hover:underline"
          >
            Login
          </span>
        </p>
      </div>
    </div>
  );
};

export default Forgotpassword;
